<template>
    <div>         
        <h4 class="p-2">Familias</h4>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo Escolar
                    </label>
                    <vs-select filter :loading="loadingCicloEscolar" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <vs-option v-for="(option, index) in ciclosEscolares" :key="index"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <label for="programa" class="pl-3 mr-1 labelInput">Programa</label>
                <form autocomplete="off">
                    <vs-select filter :loading="loadingPrograma" id="programa" placeholder="Programa" v-model="programa"  :disabled="!programas.length" class="pt-0" :key="programasId">
                        <template #message-danger v-if="errorFields.includes('programa')">
                            Requerido
                        </template>
                        <template v-if="programas.length">
                            <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <label for="grado" class="pl-3 mr-1 labelInput">Grado</label>
                <form autocomplete="off">
                    <div style="position: relative">
                        <vs-select filter :loading="loadingGrado" id="grado" placeholder="Grado" v-model="grado"  :disabled="!grados.length" class="pt-0" :key="gradosId">
                            <template #message-danger v-if="errorFields.includes('grado')">
                                Requerido
                            </template>
                            <template v-if="grados.length">
                                <vs-option v-for="option in grados" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </div>
                </form>
            </vs-col>
            <vs-col sm="12" lg="12" style="margin-top: 23px; display: flex">
                <vs-button
                    class="ml-auto"
                    @click="getDesvincularAlumno()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <tabla-desvicunlar :users="users" @refresTable="getDesvincularAlumno"></tabla-desvicunlar>
    </div>
</template>

<script>
import servicios from '../../../../api/requests/servicios'
import TablaDesvicunlar from './tabla-desvicunlar-alumno.vue'
export default {
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCiclo: false,
            programa: '',
            programas: [],
            programasId:(new Date()).getTime(),
            loadingPrograma: false,
            grado: '',
            grados: [],
            gradosId:(new Date()).getTime(),
            loadingGrado: false,
            errorFields: [],
            loadingCicloEscolar: false,
            users:[],
        }
    },
    components:{
        TablaDesvicunlar
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        async getInstituciones(){
            try {
                const response = await servicios.getInstitucion()
                this.instituciones = response.data
            }
            catch{
                
            }
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.cicloEscolar = ''
                try {
                    this.loadingCicloEscolar = true
                    const { data: response } = await servicios.getCiclosEscolares(this.institucion)
                    this.ciclosEscolares = response
                    this.cicloId = (new Date()).getTime()
                    this.loadingCicloEscolar = false
                }catch(error){
                    this.loadingCicloEscolar = false
                    console.log(error)
                }
            }
        },
        async getPrograma(){
            if (this.cicloEscolar) {
                try {
                    this.loadingPrograma = true
                    const {data: response} = await servicios.getPrograma(this.institucion)
                    this.programas = response
                    this.programasId = (new Date()).getTime()
                    this.loadingPrograma = false
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async getGradoAcademico(){
            if (this.programa) {
                try {
                    this.loadingGrado = true
                    const {data: response} = await servicios.getGradoAcademico(this.programa)
                    this.grados = response
                    this.gradosId = (new Date()).getTime()
                    this.loadingGrado = false
                } catch (error) {
                    console.log(error)
                }
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.programa) {
                this.errorFields.push('programa')
            }
            if (!this.grado) {
                this.errorFields.push('grado')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async getDesvincularAlumno(page) {
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                try {
                    let params = {
                        "institucion_id": this.institucion,
                        "ciclo_escolar_id": this.cicloEscolar,
                        "programa_id": this.programa,
                        "grado_id": this.grado
                    }
                    params.page = page ? page : '1'
                    const { data: response } = await servicios.getDesvincularAlumno(params)
                    this.users = this.getEliminarNameKey(response)
                    loading.close()
                }
                catch(error){
                    console.log(error)
                    loading.close()
                    
                }
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
    },
    watch:{
        institucion(){
            this.cicloEscolar = ''
            this.users = []
            this.programa = ''
            this.grado = ''
            this.getCicloEscolar()
        },
        cicloEscolar(){
            this.users = []
            this.programa = ''
            this.grado = ''
            this.getPrograma()
        },
        programa(){
            this.users = []
            this.grado = ''
            this.getGradoAcademico()
        },
        grado(){
            this.users = []
        }
    }
}
</script>
